module.exports = __webpack_public_path__ + "media/images/xpass/icons/map-6a768f038987248f5f0c439e609b7faf.svg";